<template>
  <div class="fill-height d-flex flex-column">
    <v-container fluid v-if="filteredList.length > 0" class="pa-0">
      <v-col
        v-for="itemLote in filteredList"
        :key="`${itemLote.idProgramacaoAbateAlocado}-Column`"
        cols="12"
      >
        <CardItemLoteAlocado
          :itemLote="itemLote"
          :itemData="itemData"
          :itemPlanta="itemPlanta"
          @animaisChanged="animaisChanged"
        />
      </v-col>
    </v-container>
    <v-container fluid v-else class="pa-0">
      <v-col>
        <v-card
          flat
          height="290px"
          width="100%"
          class="card-dias-planta-abate-lotes"
        >
          <v-layout row justify-center fill-height ma-0>
            <v-flex lg11 class="spacing-nenhum-lote-alocado">
              <span class="label-adicionar-lotes">Nenhum Lote Selecionado</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-col>
    </v-container>
    <v-col cols="12" class="pt-0">
      <CardTotalPesoMedioDiario :itemData="itemData" :itemPlanta="itemPlanta" />
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { daysBetweenDates } from "@/filters/utils";

import CardItemLoteAlocado from "@/modules/programacaoAbate/components/CardItemLoteAlocado";
import CardTotalPesoMedioDiario from "@/modules/programacaoAbate/components/CardTotalPesoMedioDiario";

export default {
  name: "CardLoteAlocadoColunm",
  components: {
    CardItemLoteAlocado,
    CardTotalPesoMedioDiario
  },
  props: {
    itemData: {
      type: Object,
      default: {}
    },
    itemPlanta: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState(["extensionistas"]),
    ...mapState("programacaoAbate", ["listaDatas", "listBatchsAllocated"]),
    filteredList() {
      if (!this.listBatchsAllocated) return [];

      let filteredList = this.listBatchsAllocated.filter(
        item =>
          item.cdPlantaAbate === this.itemPlanta.cdPlantaAbate &&
          item.stDiaAlocado === this.itemData.value
      );

      return filteredList.map(entry => {
        let dataAlocado = this.listaDatas.find(
          item => item.value === entry.stDiaAlocado
        );
        const nrDiasAlojado = this.daysBetweenDates(
          dataAlocado.text,
          "DD/MM/YYYY",
          entry.loteProducao.dtAlojamento,
          "YYYYY-MM-DD"
        );
        return { ...entry, nrDiasAlojado };
      });
    }
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
      "ActionChangeEditWeight"
    ]),
    daysBetweenDates,
    changeEditarPeso(itemLote) {
      this.ActionChangeEditWeight(itemLote);
    },
    animaisChanged(qtAnimais) {
      this.$emit("animaisChanged", qtAnimais);
    }
  }
};
</script>

<style></style>
